import { useAuth } from '../auth/useAuth';

/** Where a refused user is told to go. Matches the sign-in help line on the client prototype. */
export const ACCESS_SUPPORT_EMAIL = 'support@conscierra.au';

/**
 * BT001 #19758 — rendered IN PLACE OF the app shell when the signed-in account is not a
 * client-portal user (no client app role, no PortalUsers row, or Entra refused the API token).
 *
 * Shows only the signed-in UPN and a contact route — nothing about the portal's shape (ISO 27001
 * A.8.3). The one action is Sign out and use another account, via logoutRedirect(): the account is
 * VALID, so loginRedirect() would re-authenticate it silently and land straight back here (the loop
 * operator decision (a) exists to prevent). logoutRedirect clears the MSAL session and lets the user
 * pick a different account.
 */
export function NoAccess() {
  const { email, logout } = useAuth();

  return (
    <main className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md rounded-lg border border-sand-200 bg-white p-6 shadow-sm sm:p-8">
        <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">Conscierra Client Portal</p>
        <h1 className="mt-2 text-xl font-bold text-gray-900">Access denied</h1>
        <p className="mt-3 text-sm text-gray-700">
          You&apos;re signed in as{' '}
          <span className="font-medium text-gray-900 break-all">{email || 'an unknown account'}</span>.
        </p>
        <p className="mt-2 text-sm text-gray-700">
          This account isn&apos;t a client-portal user, so there&apos;s nothing to show here.
        </p>
        <p className="mt-2 text-sm text-gray-700">
          If you think you should have access, contact{' '}
          <a className="font-medium text-fern-700 underline hover:text-fern-800" href={`mailto:${ACCESS_SUPPORT_EMAIL}`}>
            {ACCESS_SUPPORT_EMAIL}
          </a>
          .
        </p>
        <button
          type="button"
          onClick={logout}
          className="mt-6 inline-flex w-full items-center justify-center rounded-md bg-fern-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-fern-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-fern-600 focus-visible:ring-offset-2"
        >
          Sign out and use another account
        </button>
      </div>
    </main>
  );
}
